import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function SchemaRequiredCard({ caseId }: { caseId: string }) {
  const { t } = useTranslation()
  return (
    <section className="space-y-3 rounded-lg border border-border bg-muted/40 p-5">
      <h2 className="text-base font-semibold">{t('tableMapping.schemaRequired.title')}</h2>
      <p className="text-sm text-muted-foreground">
        {t('tableMapping.schemaRequired.description')}
      </p>
      <Button asChild variant="solid">
        <Link to={`/cases/${caseId}/schema`}>{t('tableMapping.schemaRequired.action')}</Link>
      </Button>
    </section>
  )
}
